import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useLang } from "@/i18n";

export const TITOLARE = {
  ragione: "PIESSETI Srl",
  marchio: "PST Pellet",
  piva: "14760760968",
  email: "info@pstpellet.com",
  pec: "pst@pecimprese.it",
  tel: "+39 331 6819146",
};

const H = ({ children }) => (
  <h4 className="font-display font-bold uppercase tracking-tight text-base mt-6 mb-2 text-ink">{children}</h4>
);
const P = ({ children }) => (
  <p className="text-sm text-ink/70 leading-relaxed mb-2">{children}</p>
);

const CONTACT = `${TITOLARE.ragione} (${TITOLARE.marchio}) — P.IVA ${TITOLARE.piva} · ${TITOLARE.email} · PEC ${TITOLARE.pec} · Tel. ${TITOLARE.tel}.`;

const CONTENT = {
  it: {
    privacyTitle: "Informativa sulla Privacy",
    cookieTitle: "Cookie Policy",
    privacy: [
      [null, "Ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 (\"GDPR\") e del D.Lgs. 196/2003 e s.m.i. (Codice Privacy), la presente informativa descrive le modalità di trattamento dei dati personali degli utenti che interagiscono con questo sito e che inviano richieste tramite il modulo di contatto/preventivo."],
      ["Titolare del trattamento", CONTACT],
      ["Tipologie di dati trattati", "Dati anagrafici e di contatto conferiti volontariamente tramite il modulo (nome e cognome, azienda/ragione sociale, email, telefono, località di destinazione) e ogni ulteriore informazione inserita nel campo messaggio. Durante la navigazione possono inoltre essere raccolti dati tecnici (es. cookie) secondo quanto indicato nella Cookie Policy."],
      ["Finalità e base giuridica", "I dati sono trattati per: (a) riscontrare le richieste di preventivo ed eseguire misure precontrattuali (art. 6.1.b GDPR); (b) dar seguito al contatto commerciale sulla base del consenso (art. 6.1.a GDPR); (c) adempiere a obblighi di legge (art. 6.1.c GDPR)."],
      ["Modalità e conservazione", "Il trattamento avviene con strumenti informatici e telematici, con misure idonee a garantire sicurezza e riservatezza. I dati sono conservati per il tempo strettamente necessario alle finalità indicate e, in caso di rapporto commerciale, nei termini previsti dalla normativa civilistica e fiscale."],
      ["Comunicazione dei dati", "I dati potranno essere trattati da soggetti autorizzati e da fornitori di servizi (es. hosting, posta elettronica) nominati responsabili ai sensi dell'art. 28 GDPR. I dati non sono diffusi né trasferiti verso Paesi terzi in assenza di adeguate garanzie."],
      ["Diritti dell'interessato", `L'interessato può esercitare i diritti previsti dagli artt. 15-22 GDPR (accesso, rettifica, cancellazione, limitazione, portabilità, opposizione e revoca del consenso) scrivendo a ${TITOLARE.email}. Ha inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).`],
      ["Natura del conferimento", "Il conferimento dei dati obbligatori è necessario per dare riscontro alla richiesta; il mancato conferimento rende impossibile l'evasione della stessa."],
    ],
    cookie: [
      [null, "Questo sito utilizza cookie e tecnologie analoghe per garantirne il corretto funzionamento e, previo consenso, per finalità di analisi e miglioramento dell'esperienza di navigazione, in conformità al GDPR e alle Linee guida del Garante Privacy."],
      ["Cookie tecnici (necessari)", "Indispensabili per il funzionamento del sito e per memorizzare le preferenze sui cookie. Non richiedono consenso e non possono essere disattivati."],
      ["Cookie analitici / di terze parti", "Utilizzati, solo previo consenso, per raccogliere informazioni aggregate sull'utilizzo del sito. Vengono installati solo dopo l'accettazione tramite il banner e possono essere revocati in qualsiasi momento."],
      ["Gestione delle preferenze", "Puoi accettare o rifiutare i cookie non essenziali tramite il banner. È inoltre possibile gestire i cookie dalle impostazioni del browser. La revoca del consenso è sempre possibile."],
      ["Titolare", CONTACT],
    ],
  },
  en: {
    privacyTitle: "Privacy Policy",
    cookieTitle: "Cookie Policy",
    privacy: [
      [null, "Pursuant to Articles 13 and 14 of Regulation (EU) 2016/679 (\"GDPR\") and Italian Legislative Decree 196/2003 (Privacy Code), this notice describes how the personal data of users who interact with this website and submit requests via the contact/quote form are processed."],
      ["Data Controller", CONTACT],
      ["Types of data processed", "Identification and contact data voluntarily provided through the form (full name, company/business name, email, phone, delivery location) and any further information entered in the message field. Technical data (e.g. cookies) may also be collected during browsing as described in the Cookie Policy."],
      ["Purposes and legal basis", "Data are processed to: (a) respond to quote requests and carry out pre-contractual measures (Art. 6.1.b GDPR); (b) follow up on the commercial contact based on consent (Art. 6.1.a GDPR); (c) comply with legal obligations (Art. 6.1.c GDPR)."],
      ["Processing methods and retention", "Processing is carried out with IT and electronic tools, with suitable measures to ensure security and confidentiality. Data are kept for the time strictly necessary for the stated purposes and, in the event of a commercial relationship, within the terms set by civil and tax law."],
      ["Disclosure of data", "Data may be processed by authorised persons and by service providers (e.g. hosting, email) appointed as data processors under Art. 28 GDPR. Data are not disseminated nor transferred to third countries without adequate safeguards."],
      ["Rights of the data subject", `The data subject may exercise the rights under Articles 15-22 GDPR (access, rectification, erasure, restriction, portability, objection and withdrawal of consent) by writing to ${TITOLARE.email}. They also have the right to lodge a complaint with the Italian Data Protection Authority (www.garanteprivacy.it).`],
      ["Nature of provision", "Providing the mandatory data is necessary to respond to the request; failure to provide it makes it impossible to process the request."],
    ],
    cookie: [
      [null, "This website uses cookies and similar technologies to ensure it works correctly and, with your consent, for analytics and to improve the browsing experience, in compliance with the GDPR and the guidelines of the Italian Data Protection Authority."],
      ["Technical cookies (necessary)", "Essential for the website to work and to store cookie preferences. They do not require consent and cannot be disabled."],
      ["Analytics / third-party cookies", "Used, only with prior consent, to collect aggregated information on website usage. They are installed only after acceptance via the banner and can be withdrawn at any time."],
      ["Managing preferences", "You can accept or reject non-essential cookies via the banner. Cookies can also be managed from your browser settings. Consent can always be withdrawn."],
      ["Data Controller", CONTACT],
    ],
  },
};

export function PolicyDialog({ type, children }) {
  const { lang } = useLang();
  const c = CONTENT[lang] || CONTENT.it;
  const blocks = type === "cookie" ? c.cookie : c.privacy;
  const title = type === "cookie" ? c.cookieTitle : c.privacyTitle;
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent
        data-testid={`policy-dialog-${type}`}
        className="max-w-2xl max-h-[85vh] overflow-y-auto rounded-none border-2 border-ink/80 bg-white"
      >
        <DialogHeader>
          <DialogTitle className="font-display font-extrabold uppercase tracking-tight text-2xl text-ink">{title}</DialogTitle>
        </DialogHeader>
        <div>
          {blocks.map(([h, body], i) => (
            <div key={i}>
              {h && <H>{h}</H>}
              <P>{body}</P>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
